import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout, Popover } from "antd";
import CustomScrollbars from "util/CustomScrollbars";

import { onVerticalNavStyleChange, switchLanguage, toggleCollapsedSideNav } from "../../appRedux/actions/Setting";
import UserInfo from "components/UserInfo";
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI,
  TAB_SIZE,
  VERTICAL_NAVIGATION
} from "constants/ThemeSetting";
import HorizontalNav from "./HorizontalNav";
import Auxiliary from "util/Auxiliary";

const { Header } = Layout;

class Topbar extends Component {


  render() {
    const { locale, navStyle, horizontalNavPosition, navCollapsed, width } = this.props;
    let { verticalNavStyle } = this.props;
    if (width < TAB_SIZE && verticalNavStyle === NAV_STYLE_FIXED) {
      verticalNavStyle = NAV_STYLE_DRAWER;
    }
    return (
      <Auxiliary>
        {navStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER && width >= TAB_SIZE ?
          <div className="gx-nav-header"><HorizontalNav /></div> : null}
        <Header
          className={`${navStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER ? 'gx-layout-header-horizontal' : ''}`}>
          {width < TAB_SIZE || (navStyle === VERTICAL_NAVIGATION && verticalNavStyle === NAV_STYLE_DRAWER) ?
            <div className="gx-linebar gx-mr-3">
              <i className="gx-icon-btn icon icon-menu"
                onClick={() => {
                  if (width <= TAB_SIZE || verticalNavStyle === NAV_STYLE_DRAWER) {
                    this.props.toggleCollapsedSideNav(!navCollapsed);
                  } else if (verticalNavStyle === NAV_STYLE_FIXED) {
                    this.props.onVerticalNavStyleChange(NAV_STYLE_MINI)
                  } else {
                    this.props.onVerticalNavStyleChange(NAV_STYLE_FIXED)
                  }
                }}
              />

            </div> : null}


          <h3><span className="gx-text-light "> ¡Bienvenido!</span></h3>

          {width >= TAB_SIZE && navStyle === HORIZONTAL_NAVIGATION ? <div className="gx-site-logo gx-mr-2">
            <img src={require("assets/images/davIcon.png")} />
          </div> : null}



          {width >= TAB_SIZE && navStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER ?
            <HorizontalNav /> : null}
          <ul className="gx-header-notifications gx-ml-auto">
            <li className="gx-user-nav">
              <span className="gx-pointer gx-d-block">
                <UserInfo />
              </span>
            </li>
          </ul>
        </Header>
        {width >= TAB_SIZE && navStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER ?
          <div className="gx-nav-header gx-nav-header-ble"><HorizontalNav /></div> : null}
      </Auxiliary>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { navStyle, verticalNavStyle, horizontalNavPosition, locale, width, navCollapsed } = settings;
  return { navStyle, verticalNavStyle, horizontalNavPosition, locale, width, navCollapsed }
};

export default connect(mapStateToProps, { onVerticalNavStyleChange, toggleCollapsedSideNav, switchLanguage })(Topbar);



// WEBPACK FOOTER //
// ./src/containers/Topbar/index.js